import React, { useEffect, useState } from 'react';
import Tabs from '@material-ui/core/Tabs';
import { TextField, Typography } from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import {
  StyledForm,
  StyledTab,
  StyledContainer,
  StyledSchedulePaper,
} from './styles';

function TimeInputField(props) {
  return (
    <TextField
      margin="normal"
      type="time"
      fullWidth
      InputLabelProps={{
        shrink: true,
      }}
      inputProps={{
        step: 300,
      }}
      {...props}
    />
  );
}

const WeekDays = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'];
const WeekDayIndex = Object.freeze({
  [WeekDays[0]]: 0,
  [WeekDays[1]]: 1,
  [WeekDays[2]]: 2,
  [WeekDays[3]]: 3,
  [WeekDays[4]]: 4,
  [WeekDays[5]]: 5,
  [WeekDays[6]]: 6,
});

function initialWeekDay() {
  return WeekDays[0];
}

export function ScheduleSettings({ schedule, onUpdate }) {
  const [displayedDay, setDisplayedDay] = useState(initialWeekDay);
  const [values, setValues] = useState([]);
  const [isDirty, setIsDirty] = useState(false);

  useEffect(() => {
    const schedules = JSON.parse(schedule);
    const allSchedules = WeekDays.map((_, i) => {
      if (schedules[i]) {
        return {
          from: schedules[i].abre,
          to: schedules[i].fecha,
        };
      }

      return {
        from: '',
        to: '',
      };
    });
    setValues(allSchedules);
  }, []);

  useEffect(() => {
    if (!isDirty) return;

    const updatedSchedule = values
      .map((weekDaySchedule, index) => ({
        dayIndex: index,
        schedule: weekDaySchedule,
      }))
      .filter(
        (weekDaySchedule) =>
          weekDaySchedule.schedule.from && weekDaySchedule.schedule.to,
      )
      .reduce(
        (scheduleObj, weekDaySchedule) => ({
          ...scheduleObj,
          [weekDaySchedule.dayIndex]: {
            abre: weekDaySchedule.schedule.from,
            fecha: weekDaySchedule.schedule.to,
          },
        }),
        {},
      );

    onUpdate(updatedSchedule);
  }, [values, isDirty]);

  const handleChangeDisplayedDay = (_ev, value) => {
    setDisplayedDay(value);
  };

  const handleChangeTime = (field) => (ev) => {
    setValues((prevValues) => {
      const scheduleIndex = WeekDayIndex[displayedDay];

      return prevValues.map((value, i) => {
        if (i === scheduleIndex) {
          return {
            ...value,
            [field]: ev.target.value,
          };
        }
        return value;
      });
    });
    setIsDirty(true);
  };

  return (
    <StyledContainer>
      <Typography variant="h4">Horário de funcionamento</Typography>

      <StyledSchedulePaper>
        <Tabs
          value={displayedDay}
          onChange={handleChangeDisplayedDay}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          orientation={isMobile ? 'vertical' : 'horizontal'}
        >
          {WeekDays.map((weekDay) => (
            <StyledTab key={weekDay} label={weekDay} value={weekDay} />
          ))}
        </Tabs>

        <StyledForm>
          <TimeInputField
            label="Das"
            value={values[WeekDayIndex[displayedDay]]?.from}
            onChange={handleChangeTime('from')}
          />

          <TimeInputField
            label="Até"
            value={values[WeekDayIndex[displayedDay]]?.to}
            onChange={handleChangeTime('to')}
          />
        </StyledForm>
      </StyledSchedulePaper>
    </StyledContainer>
  );
}
